import {Component, Inject,  OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import * as moment from 'moment';
import * as _ from 'lodash';
import {BsLocaleService} from 'ngx-bootstrap/datepicker';
import {ActivatedRoute} from '@angular/router';
import {select, Store} from '@ngrx/store';
import * as fromDashboard from '../../reducers';
import {LoadOrdersStatisticListAction, OrdersStatisticListExportAction} from '../../actions/orders-statistic-list';
import {OrdersStatistic} from '../../models/orders-statistic';
import * as Highcharts from 'highcharts';
import {defineLocale, frLocale} from 'ngx-bootstrap/chronos';
defineLocale('fr', frLocale);

@Component({
  selector: 'storever-dashboard-orders',
  templateUrl: './dashboard-orders.component.html',
  styleUrls: ['./dashboard-orders.component.scss']
})
export class DashboardOrdersComponent implements OnInit , OnDestroy {
  private sub$: Subscription;
  private subscriptions = [];
  localeDate = 'FR';
  minDate: Date;
  // tslint:disable-next-line:no-any
  defaultValue: any;
  granularity: string;
  startDate: string;
  endDate: string;
  dataSum: OrdersStatistic[];
  dataCurrent: OrdersStatistic[];
  highchartsRef = Highcharts;
  updateFromInput: boolean;
  totalDeploy = 0;
  totalExchange = 0;
  totalSum = 0;
  // tslint:disable-next-line
  chartOptions: any = {
    'title': {
      'text': 'Orders Counter'
    },
    'xAxis': {
      'categories': [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      tickmarkPlacement: 'on',
      title: {
        enabled: false
      }
    },
    'yAxis': {
      'title': {
        'text': 'Orders'
      }
    },
    tooltip: {
      split: true,
      valueSuffix: ' Orders'
    },
    plotOptions: {
      area: {
        stacking: 'normal',
        lineColor: '#666666',
        lineWidth: 1,
        marker: {
          lineWidth: 1,
          lineColor: '#666666'
        }
      }
    },
    'series': []
  };
  // tslint:disable-next-line:no-any
  ranges: any = [{
      value: [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()],
      label: 'Last 7 Days'
    },
                 {
      value: [ new Date(new Date().setDate(new Date().getDate() - 30)) , new Date() ],
      label: 'Last Month'
    },
                 {
      value: [ new Date(new Date().setDate(new Date().getDate() - 90)) , new Date() ],
      label: 'Last 3 Months'
    },
                 {
      value: [ new Date(new Date().setDate(new Date().getDate() - 180)) , new Date() ],
      label: 'Last 6 Months'
    },
                 {
      value: [ new Date(new Date().setDate(new Date().getDate() - 365)), new Date()],
      label: 'Last Year'
    }];
  // tslint:disable-next-line:no-any
  btnList:  any[];
  selectedBtn: string;
  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private localeService: BsLocaleService,
              private store: Store<fromDashboard.AppState>,
              private activatedRoute: ActivatedRoute) {

    this.initDatePicker();
    this.initGranularityBtn();

  }

  ngOnInit(): void {
    this.sub$ = this.store.pipe(select(fromDashboard.selectors.getOrdersStatistics)).subscribe(data => {
      if (data) {
        this.localeService.use(this.localeDate);
        this.dataCurrent = data;
        if (this.granularity) {
          this.updateList(this.granularity);
        } else {
          this.updateList('weekly');
        }
      }

    });
    this.subscriptions.push(this.sub$);
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  applyFilter(query: string): void {
    if (query) {
      this.startDate = moment(query[0]).format('YYYY-MM-DD');
      this.endDate = moment(query[1]).format('YYYY-MM-DD');
      this.store.dispatch(new LoadOrdersStatisticListAction({
        startdate: this.startDate ,
        enddate:  this.endDate,
      }));
    }
  }
  initDatePicker(): void {
    this.minDate = new Date(2020, 0);
    this.minDate.setDate(this.minDate.getDate());
    this.defaultValue = [ moment(new Date()).add('days', -30).format('DD/MM/YYYY' ) ,
                          moment().format('DD/MM/YYYY' )];
  }

  initGranularityBtn(): void {
    this.btnList = [
      {
        icon: 'fad fa-calendar-day',
        text: 'GENERIC_DAILY',
        code: 'daily',
      },
      {
        icon: 'fad fa-calendar-week',
        text: 'GENERIC_WEEKLY',
        code: 'weekly',
      },
      {
        icon: 'fad fa-calendar-alt',
        text: 'GENERIC_MONTHLY',
        code: 'monthly',
      },
    ];
    this.selectedBtn = 'weekly';

  }
  // @ts-ignore
  updateList(event: string): void {
    this.granularity = event;
    const self = this;
    if (event === 'daily') {
      this.dataSum = this.dataCurrent;
    } else if (event === 'monthly') {
      this.totalDeploy = 0;
      this.totalExchange = 0;
      this.totalSum = 0;
      // tslint:disable-next-line:typedef
      this.dataSum = _.values(this.dataCurrent.reduce(function (obj, item) {
        const index = moment(item.date).format('DD-MM-YYYY').split('-').slice(1, 3).join(', ')
        const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        obj[index] = {
          date: month[parseInt(index.split(',')[0], 10) - 1] + ',' + index.split(',')[1],
          deploy: (obj[index] && obj[index].deploy || 0) + item.deploy,
          exchange: (obj[index] && obj[index].exchange || 0) + item.exchange,
          sum: (obj[index] && obj[index].sum || 0) + item.sum
        }

        self.totalDeploy += item.deploy;
        self.totalExchange += item.exchange;
        self.totalSum += item.sum;
        return obj
      }, {}));
    } else if (event === 'weekly') {
      this.totalDeploy = 0;
      this.totalExchange = 0;
      this.totalSum = 0;
      // tslint:disable-next-line:typedef
      this.dataSum = _.values(this.dataCurrent.reduce(function (obj, item) {
        const index = moment(item.date, 'YYYY-MM-DD').week();
        obj[index] = {
          date: 'Week ' + index + '   ( ' + self.getDateFromWeekStart(index) + ' - ' + self.getDateFromWeekEnd(index) + ' )',
          deploy: (obj[index] && obj[index].deploy || 0) + item.deploy,
          exchange: (obj[index] && obj[index].exchange || 0) + item.exchange,
          sum: (obj[index] && obj[index].sum || 0) + item.sum
        }
        self.totalDeploy += item.deploy;
        self.totalExchange += item.exchange;
        self.totalSum += item.sum;
        return obj
      }, {}));
    }
    this.initChart();
  }

  initChart(): void {
    const self = this;
    if (this.dataSum.length > 0) {
      /* tslint:disable */
      const categories = _.map(this.dataSum, function (item: any) {
        const newItem = _.clone(item);
        newItem.date = self.dateFormat(item.date);
        return _.omit(newItem, ['deploy', 'exchange', 'sum']);
      });
      // tslint:disable-next-line:no-any
      this.chartOptions.xAxis.categories = categories.map(item => item.date);
      let deploy = [], exchange = [], sum = [];
      _.map(this.dataSum, function (item: any) {
        deploy.push(item.deploy);
        exchange.push(item.exchange);
        sum.push(item.sum);

      })
      this.chartOptions.series = [{ name: 'Sum', data: sum } , { name: 'Deploy', data: deploy }, { name: 'Exchange', data: exchange }];
      this.updateFromInput = true;

    }
  }
  // tslint:disable-next-line:no-any
  dateFormat(event: any): any {
    if (moment(event , 'DD-MM-YYYYTHH:mm:ssZZ').isValid() && event.search('Week')) {
      return  moment(event).format('DD/MM/YYYY' );
    } else {
      return event;
    }

  }
  getDateFromWeekStart = function(week) {
    var d = new Date();
    var year = d.getFullYear();
    return moment().day("Monday").year(year).week(week).format('DD/MM/YYYY' );
  };

  getDateFromWeekEnd = function(week) {
    var d = new Date();
    var year = d.getFullYear();
    return moment().day("Sunday").year(year).week(week + 1).format('DD/MM/YYYY' );
  };

  export(event: any): any {
      this.store.dispatch(new OrdersStatisticListExportAction({
        startdate: this.startDate ,
        enddate:  this.endDate,
      }));
  }
}
